// Which POSTs are READS (KAN-897 / KAN-886 follow-up). Supabase sends RPC calls
// and edge-function calls as POST even when they only read, so a screen that is
// loading looked like "a save in progress" and the quiet app update waited
// forever on busy screens. A request is a read ONLY when its name says so by our
// naming convention; anything else — including every unknown name — still counts
// as a write, so the update never cuts off a real save (fail closed).

const READ_RPC = /^(get|list|check|count|search|fetch|find|is|has|current|rpc_distinct|rpc_get|rpc_list)_[a-z0-9_]+$/;
const READ_FUNCTION = /^(get|list|check)-[a-z0-9-]+$/;
// Fire-and-forget telemetry: losing one report on a reload is harmless.
const TELEMETRY_FUNCTIONS = new Set(['log-client-error']);

export function isReadOnlyRequest(url) {
  try {
    const path = new URL(String(url), 'http://x').pathname;
    let m = /\/rest\/v1\/rpc\/([^/?]+)$/.exec(path);
    if (m) return READ_RPC.test(m[1]);
    m = /\/functions\/v1\/([^/?]+)$/.exec(path);
    if (m) return READ_FUNCTION.test(m[1]) || TELEMETRY_FUNCTIONS.has(m[1]);
    return false;
  } catch (_) {
    return false;
  }
}
